export default {
  hero_badge: "사회동역학 연구소 · 2026",
  hero_title_1: "사회를 측정하는",
  hero_title_2: "늘푸른바다 사회동역학연구소",
  hero_subtitle: "Everblue Sea Institute for Social Dynamics",
  hero_desc_1: "데이터는 사람이 만든 기록입니다.",
  hero_desc_2: "저희는 그 기록에서 사회의 문장을 다시 씁니다.",
  hero_compass: "민중의 고통을 가리키는 나침반",
  nav_analysis: "분석",
  nav_engines: "엔진",
  nav_papers: "논문",
  nav_institute: "연구소",
  stat_countries: "개국 분석",
  stat_acled: "ACLED 이벤트",
  stat_axioms: "사회구조 설계공리",
  stat_ssrn: "SSRN 등재 논문",
  latest_title: "최신 분석",
  latest_all: "전체 보러가기",
  engines_label: "분석 엔진",
  engines_title: "12개 분석 엔진으로 사회의 결을 읽다",
  engines_sub: "4개 핵심 엔진과 8개 하위엔진이 사회 현상을 다층적으로 계측합니다.",
  papers_label: "Papers · Research",
  papers_title: "논문 및 연구 보고서",
  papers_sub: "SSRN · Giseub Kim · ORCID 0009-0004-7638-0182",
  about_label: "About the Lab",
  about_title: "데이터는 사람이 만든 기록입니다.\n저희는 그 기록에서\n사회의 문장을 다시 씁니다.",
  about_compass: "민중의 고통을 가리키는 나침반",
  about_desc: "늘푸른바다 사회동역학연구소는 독립 연구 조직입니다. 공공 데이터와 자체 프레임워크를 결합해 사회동역학적 리포트를 발행하며, 모든 결과물을 원자료 코드와 함께 누구나 노트북을 통해 공개합니다.",
  hero_title_kr_label: "늘푸른바다 사회동역학 연구소",
  // 국가 검색
  country_search_hint: "↑↓ 이동 · Enter 열기",
  country_search_clear: "지우기",
  country_report_count_one: "{{count}}편",
  country_report_count_other: "{{count}}편",
  country_reports_none: "보고서 없음",
  country_page_kicker: "국가별 보고서",
  country_page_summary: "이 나라를 다룬 보고서 {{count}}편 · 최신순",
  country_page_switch: "다른 나라 찾기",
  country_page_back: "홈으로",
  country_empty_title: "아직 이 나라를 다룬 보고서가 없습니다.",
  country_empty_desc: "새 보고서가 올라오면 이곳에 자동으로 모입니다. 다른 나라를 검색해 보세요.",
  country_not_found_title: "찾을 수 없는 국가 코드입니다.",
  country_not_found_desc: "위 검색창에서 나라 이름을 입력해 주세요.",
  country_scope_standalone: "단독",
  country_scope_regional: "권역별",
  country_open_report: "보고서 열기",
  // 보고서 통합 검색
  search_label: "나라·주제어로 보고서 찾기",
  search_placeholder: "나라·제목·주제어 (예: 인도네시아, 시위, BSLI)",
  search_aria: "나라 이름, 보고서 제목, 주제어, 분류로 검색",
  search_no_match: "일치하는 나라나 보고서가 없습니다.",
  search_group_countries: "국가",
  search_group_categories: "분류",
  search_group_reports: "보고서",
  search_view_all: "모든 결과 보기",
  search_category_hint: "이 분류에서 보기",
  search_page_kicker: "보고서 검색",
  search_page_title: "「{{q}}」 검색 결과",
  search_page_prompt: "무엇을 찾으세요?",
  search_page_summary_one: "보고서 {{count}}편",
  search_page_summary_other: "보고서 {{count}}편",
  search_page_countries: "나라별 보고서 모아 보기",
  search_filter_all: "전체",
  search_filter_label: "분류로 거르기",
  search_sort_label: "정렬",
  search_sort_newest: "최신순",
  search_sort_relevance: "관련도순",
  search_empty_title: "일치하는 보고서가 없습니다.",
  search_empty_desc: "띄어쓰기를 빼거나 다른 낱말로 찾아보세요. 나라 이름, 보고서 제목, 엔진 이름(Λ¹², BSLI, 봉기지수 …)으로 찾을 수 있습니다. 본문은 검색하지 않습니다.",
  search_prompt_desc: "나라 이름, 보고서 제목의 낱말, 엔진·분류 이름으로 찾을 수 있습니다.",
};
